import React from "react";

/**
 * @author
 * @function Team
 **/

export const Team = (props) => {
  return <div>Team</div>;
};
